import React from 'react';
import PropTypes from 'prop-types';
import {get} from './Storage';
import axios from 'axios';
import { MGSiteButton } from 'mgUiKit';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'MGNewsComponent';

class NewsConfirmButton extends React.Component {
    constructor(props) {
        super(props);
        this.handleConfirmNews = this.handleConfirmNews.bind(this);

    }

    handleConfirmNews (event) {
        var newsId = this.props.newsId;
        var url = AppSettings['env'].urlUserBoxNewsSetReadByuser.replace("[NEWS_ID]", newsId);
        axios.put(url)
            .then(({data, status, statusText}) => {
                if (data.errors.length == 0) {
                    this.context.realoadNews(false);
                    if (data.errors.length == 0) {
                    }
                } else {
                    this.setState({
                        showLoading: false,
                        error: true,
                        errorMessage: "La tua sessione è scaduta",
                        data: {}
                    });
                }
            })

            .catch(({data, status, statusText}) => {
                this.setState({
                    showLoading: false,
                    error: true,
                    errorMessage: "",
                    data: {}
                });
            });
    }

    render() {
        return (
            <div style={{marginTop:"15px"}}>                
                <MGSiteButton
                    title="Ho letto e accetto"             
                    class=""
                    label="Ho letto e accetto"
                    disabled={false}
                    primary={false}
                    isButton={true}
                    fullWidth={false}
                    actionFunc={this.handleConfirmNews}
                />               

            </div>
        );
    }
}

NewsConfirmButton.displayName = componentName;

// PropTypes validation
NewsConfirmButton.propTypes = {
    newsId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
// default props
NewsConfirmButton.defaultProps = {
    newsId: '0'
};
NewsConfirmButton.contextTypes = {
    realoadNews: PropTypes.func
}
export default NewsConfirmButton;